/**
 * manual-booking-redesign D13: shared helpers for a waiting manual booking (a
 * booking an admin made that is Payment due with a completion deadline).
 */

/** The deadline as "Thu, Jul 30 at 6:00 PM", in the browser timezone (CWR client source). */
export function formatFinishBy(iso: string): string {
  const d = new Date(iso);
  const day = new Intl.DateTimeFormat('en-US', { weekday: 'short', month: 'short', day: 'numeric' }).format(d);
  const time = new Intl.DateTimeFormat('en-US', { hour: 'numeric', minute: '2-digit' }).format(d);
  return `${day} at ${time}`;
}

/** The Complete step for one booking. */
export function completeStepPath(bookingId: string): string {
  return `/booking-hub/booking/${bookingId}/complete`;
}

/**
 * The deadline as "Thu at 6:00 PM", in the browser timezone: Waiting on you's row (web-account-pages
 * D12). The window is 24 or 48 hours, so the weekday is enough.
 */
export function formatFinishByDay(iso: string): string {
  const d = new Date(iso);
  const day = new Intl.DateTimeFormat('en-US', { weekday: 'short' }).format(d);
  const time = new Intl.DateTimeFormat('en-US', { hour: 'numeric', minute: '2-digit' }).format(d);
  return `${day} at ${time}`;
}

/**
 * An approved request still to pay, in Waiting on you (web-account-pages D12): one sentence for
 * the app and every website, "<name> was approved. Pay to confirm it.", and its button.
 */
export const APPROVED_PAYMENT = { after: 'was approved. Pay to confirm it.', action: 'Pay now' } as const;
